import React, {Component} from "react";
import {
    Panel,
    Modal,
    Button
}                         from "react-bootstrap";
import axios              from "axios";
import {
    ToastContainer,
    toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_NULL,
    IS_VALID,
    IS_LENGTH_ZERO,
    RETRIEVE_ALL
}                         from "utils";

import CrudComponent      from "../zynappse-crud";
import
CustomBlockMessageSchema  from "./CustomBlockMessageSchema";
import saveTrail          from "utils/saveTrail";
import FormContainer      from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class CustomBlockMessage extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;

        this.refreshTable = this.refreshTable.bind(this);
        this.saveData = this.saveData.bind(this);
        this.checkCardType = this.checkCardType.bind(this);
        this.getRelation = this.getRelation.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.getCustomBlockMessageConfig = this.getCustomBlockMessageConfig.bind(this);
        this.saveCustomBlockMessageConfig = this.saveCustomBlockMessageConfig.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    refreshTable () {
        if (
            IS_VALID(IS_VALID) &&
            typeof this.refreshTableReference === "function"
        ) {
            this.refreshTableReference();
        }
    }

    async saveData () {
        let {
            CustomBlockMessage,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId,

            name,
            cardType,
            message
        } = CustomBlockMessage;

        if (
            !IS_VALID(name) ||
            !IS_VALID(name.trim())
        ) {
            toast.error("Name is required.");
        } else if (
            cardType.length === 0
        ) {
            toast.error("Card Type is required.");
        } else  if (
            !IS_VALID(message) ||
            !IS_VALID(message.trim())
        ) {
            toast.error("Message is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let checkCardType_result = await this.checkCardType(cardType, true);

            if (checkCardType_result) {
                actions.setValue({
                    isLoadingAction: false
                });

                return;
            }

            let fd = new FormData();

            fd.append("userId", Parse.User.current().id);
            fd.append("name", name);
            fd.append("message", message);

            for (let index = 0; index < cardType.length; index++) {
                fd.append(`cardTypeIdArray[${index}]`, cardType[index].value);
            }

            let httpMethod = "post",
                url = `${WEB_PATH}/CustomBlockMessage`;

            if (
                (
                    !IS_EMPTY_STRING(formType) &&
                    formType.toUpperCase() === "UPDATE"
                ) &&
                !IS_EMPTY_STRING(formId)
            ) {
                httpMethod = "put";
                url = `${url}/${formId}`;
            }

            axios[httpMethod](url, fd)
            .then((res) => {
                let {
                    data,
                    changesObject
                } = res.data;

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    changesObject
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    async checkCardType (cardType, isCreate = false) {
        let {
            CustomBlockMessage,
            actions
        } = this.props;

        let {
            selectedData
        } = CustomBlockMessage;

        if (cardType.length === 0) {
            actions.setValue({
                isCheckingCardType: false,
                isCardTypeExist: false,
                errorMessage: ""
            });

            return;
        }

        if (!isCreate) {
            actions.setValue({
                isCheckingCardType: true
            });
        }

        let fd = new FormData();

        if (IS_VALID(selectedData)) {
            fd.append("customBlockMessageId", selectedData.id);
        }

        let cardTypeId_name = {};

        for (let index = 0; index < cardType.length; index++) {
            fd.append(`voucherCardTypeIdArray[${index}]`, cardType[index].value);

            cardTypeId_name[cardType[index].value] = cardType[index].label;
        }
        
        try {
            let res = await axios.post(
                WEB_PATH + "/CustomBlockMessage/check_cardType",
                fd
            );

            let {
                cardTypeIdArray
            } = res.data;

            let stateToUpdate = {
                isCheckingCardType: false,
                isCardTypeExist: false,
                errorMessage: ""
            };

            if (cardTypeIdArray.length !== 0) {
                stateToUpdate.isCardTypeExist = true;

                let message = "Card Type ";
                
                let updated_cardType = cardType;

                for (let id of cardTypeIdArray) {
                    message += `${cardTypeId_name[id]}, `;

                    for (let index = 0; index < updated_cardType.length; index++) {
                        let {
                            value
                        } = updated_cardType[index];
                        
                        if (value === id) {
                            updated_cardType.splice(index, 1 );
                            break;
                        }
                    }
                }

                message = message.trim();
                message = message.slice(0, message.length-1);

                message += ` ${cardTypeIdArray.length > 1 ? "are" : "is"} already assigned to other message.`;

                stateToUpdate.errorMessage = message;

                stateToUpdate.cardType = updated_cardType;
            }
            
            actions.setValue(stateToUpdate);

            if (cardTypeIdArray.length !== 0) {
                setTimeout(() => {
                    actions.setValue({
                        isCheckingCardType: false,
                        isCardTypeExist: false,
                        errorMessage: ""
                    });
                }, 3000);
            }

            return cardTypeIdArray.length !== 0 ? stateToUpdate.errorMessage : "";
        } catch (err) {
            console.log("checkCardType error");
            console.log(err);

            let stateToUpdate = {
                isCheckingCardType: false,
                isCardTypeExist: true,
                errorMessage: "Something went wrong while validating card type."
            };

            actions.setValue(stateToUpdate);

            return stateToUpdate.errorMessage;
        }
    }

    getRelation () {
        let {
            CustomBlockMessage,
            actions
        } = this.props;

        let {
            selectedData
        } = CustomBlockMessage;

        let cardTypeRelationQuery = selectedData.relation("CardType").query();

        cardTypeRelationQuery.ascending("name");

        return cardTypeRelationQuery.find();
    }

    deleteData () {
        let {
            CustomBlockMessage,
            actions
        } = this.props;

        let {
            selectedData
        } = CustomBlockMessage;

        actions.setValue({ isLoadingAction: true });

        selectedData.destroy()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    objectId: selectedData.id,
                    name: selectedData.get("name") || "",
                    message: selectedData.get("message") || ""
                }
            );
        })
        .catch((err) => {
            console.log("deleteData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        })
    }

    getCustomBlockMessageConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoadingConfig: true
        });

        let customBlockMessageQuery = new Parse.Query("CustomBlockMessageConfig");

        customBlockMessageQuery
        .equalTo("name", "APP")
        .descending("createdAt");

        customBlockMessageQuery.first()
        .then((data) => {
            let stateToUpdate = {
                isLoadingConfig: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.isActive = IS_VALID(data.get("isActive")) ? data.get("isActive") : true;
                stateToUpdate.customBlockMessageConfig = data;
            } else {
                stateToUpdate.isActive = true;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getCustomBlockMessageConfig error");
            console.log(err);

            actions.setValue({
                isLoadingConfig: false
            });
        });
    }

    saveCustomBlockMessageConfig () {
        let {
            CustomBlockMessage,
            actions
        } = this.props;
        
        let {
            isActive,
            customBlockMessageConfig
        } = CustomBlockMessage

        actions.setValue({ isSavingConfig: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(customBlockMessageConfig)) {
              resolve(customBlockMessageConfig);
            } else {
              let query = new Parse.Query("CustomBlockMessageConfig");
      
              query
              .equalTo("name", "APP")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((customBlockMessageConfig) => {
            if (IS_UNDEFINED(customBlockMessageConfig)) {
                customBlockMessageConfig = new Parse.Object("CustomBlockMessageConfig");

                customBlockMessageConfig.set("name", "APP");
            }

            customBlockMessageConfig.set("isActive", !isActive);

            return customBlockMessageConfig.save();
        })
        .then((customBlockMessageConfig) => {
            let stateToUpdate = {
                isSavingConfig: false,
                isActive: !isActive,
                showModalConfig: false,
                customBlockMessageConfig
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                isActive ? "DEACTIVATE" : "ACTIVATE",
                {
                    isActive: !isActive
                }
            );
        })
        .catch((err) => {
            console.log("saveCustomBlockMessageConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    loadOptions (input, cb) {
        let query = new Parse.Query("VoucherCardType");

        query
        .ascending("name")
        .matches("name", input, "i")
        .limit(20);

        query.find()
        .then((data) => {
            cb(
                null,
                {
                    options: data.map((item) => ({
                        label: item.get("name"),
                        value: item.id
                    }))
                }
            );
        })
        .catch((err) => {
            console.log("loadOptions error");
            console.log(err);

            cb(
                null,
                {
                    options: []
                }
            );
        });
    }

    renderModalButton () {
        let {
            CustomBlockMessage,
            actions
        } = this.props;
        
        let {
            isLoadingAction,
            formType,

            isCheckingCardType,
            isCardTypeExist
        } = CustomBlockMessage;

        let buttons = [],
            buttonAction = (
                name = "CREATE",
                loading = isLoadingAction,
                callback = this.saveData
            ) => (
                <Button
                    bsStyle="primary"
                    disabled={loading}
                    onClick={() => callback()}
                >
                    {name}
                </Button>
            ),
            buttonClose = (
                <Button
                    disabled={isLoadingAction || isCheckingCardType}
                    onClick={() => {
                        if (!isLoadingAction || !isCheckingCardType) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                    CLOSE
                </Button>
            );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    buttonAction(
                        "CREATE",
                        isLoadingAction || isCheckingCardType || isCardTypeExist
                    ),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    buttonAction(
                        "UPDATE",
                        isLoadingAction || isCheckingCardType || isCardTypeExist
                    ),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    buttonAction(
                        "DELETE",
                        isLoadingAction,
                        this.deleteData
                    ),
                    buttonClose
                );
                break;
            default:
                buttons.push(
                    buttonClose
                );
                break;
        }
        return buttons;
    }

    accessible (actionType) {
        let {
            access
          } = this.props.accessjson;
      
          if (access.length !== 0) {
            var currentPath = window.location.pathname,
                    index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
                    actions = [];

            if (access[index]) {
                actions = access[index].actions
            }

            if (actions.length != 0) {
                if (actions.indexOf(actionType.toUpperCase()) === -1) {
                    return 'none';
                } else {
                    return '';
                }
            } else {
                return 'none';
            }
        } else {
            return 'none';
        }
    }

    render () {
        let {
            CustomBlockMessage,
            accessjson,
            actions
        } = this.props;

        let {
            showModal,
            isLoadingAction,
            selectedData,
            formType,
            formTitle,

            showModalConfig,
            isSavingConfig,
            isLoadingConfig,
            isActive
          } = CustomBlockMessage;

        let crudProps = {
            schema: CustomBlockMessageSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "descending", column: "createdAt" }
            ],
            saveTrail: saveTrail,
            customView: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "VIEW",
                    formTitle: "VIEW APP BLOCK MESSAGE",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE APP BLOCK MESSAGE"
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE APP BLOCK MESSAGE",
                    formId: obj.id,
                    selectedData: obj
                };

                if (IS_VALID(obj.get("name"))) {
                    stateToUpdate.name = obj.get("name");
                }

                if (IS_VALID(obj.get("message"))) {
                    stateToUpdate.message = obj.get("message");
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) =>{
                actions.setValue({
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE APP BLOCK MESSAGE",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customItems: [
                {
                    columnName: "name",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = "";
            
                        if (IS_VALID(value)) {
                            renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
                        }
            
                        return renderValue;
                    }
                },
                {
                    columnName: "message",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = "";
            
                        if (IS_VALID(value)) {
                            renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
                        }
            
                        return renderValue;
                    }
                }
            ]
        };

        let formContainerProps = {
            actions,

            selectedData,
            formType,

            loadOptions: this.loadOptions,
            getRelation: this.getRelation,
            checkCardType: this.checkCardType
        };

        let isActivateAccessible = this.accessible("ACTIVATE") === "",
            isDeactivateAccessible = this.accessible("DEACTIVATE") === "";
        
        return (
            <div>
                <Panel>
                    <Panel.Heading
                        style={{
                            backgroundColor: '#D1282F',
                            color: 'white'
                        }}
                    >
                        <h4 style={{ display: "inline-block" }}>App Block Message</h4>
                        <div style={{ float: "right" }}>
                            <Button
                                style={(isActive ? !isDeactivateAccessible : !isActivateAccessible) ? { cursor: "not-allowed" } : null}
                                bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
                                disabled={isLoadingConfig || (isActive ? !isDeactivateAccessible : !isActivateAccessible)}
                                onClick={() => {

                                    if (
                                        (isActive ? !isDeactivateAccessible : !isActivateAccessible)
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        showModalConfig: true
                                    });
                                }}
                            >
                                {isLoadingConfig ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    isActive ? "ACTIVE" : "INACTIVE"
                                )}
                            </Button>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            })
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={showModalConfig}
                    onHide={() => {
                        if (!isSavingConfig) {
                            actions.setValue({
                                showModalConfig: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "}VOUCHER</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {`Are you sure you want to ${isActive ? "deactivate" : "activate"} App Block Message?`}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle={isActive ? "danger" : "success"}
                            disabled={isSavingConfig}
                            onClick={() => this.saveCustomBlockMessageConfig()}
                        >
                            {isActive ? "DEACTIVATE" : "ACTIVATE"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount () {
        this.getCustomBlockMessageConfig();
    }
}

import {connect}            from "react-redux";
import {bindActionCreators} from "redux";
import {generics}           from "actions";
import {
    CUSTOM_BLOCK_MESSAGE
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        CustomBlockMessage,
        accessjson
	} = state;

	return {
        CustomBlockMessage,
        accessjson
	};
}


function mapDispatchToProps(dispatch) {
    const actions = {
        setValue: (stateObject, actionType = CUSTOM_BLOCK_MESSAGE) => generics.setValue(actionType, stateObject)
    };
  
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomBlockMessage);


// WEBPACK FOOTER //
// ./components/CustomBlockMessage/index.js